// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","heroTitle":"Hero_heroTitle__ozdbJ"};